/**
 * @generated SignedSource<<58a0663e5697fe114d434a56938151d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestartContentNodeAfterPassedInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type useCardAdvanceContentNavigation_RestartContentNodeAfterPassedMutation$variables = {
  input: RestartContentNodeAfterPassedInput;
};
export type useCardAdvanceContentNavigation_RestartContentNodeAfterPassedMutation$data = {
  readonly LearnV2: {
    readonly restartContentNodeAfterPassed: {
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type useCardAdvanceContentNavigation_RestartContentNodeAfterPassedMutation = {
  response: useCardAdvanceContentNavigation_RestartContentNodeAfterPassedMutation$data;
  variables: useCardAdvanceContentNavigation_RestartContentNodeAfterPassedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "RestartContentNodeAfterPassedPayload",
        "kind": "LinkedField",
        "name": "restartContentNodeAfterPassed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCardAdvanceContentNavigation_RestartContentNodeAfterPassedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCardAdvanceContentNavigation_RestartContentNodeAfterPassedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "78fbb76df88a1ea15dd059cd6b2ba2b9",
    "id": null,
    "metadata": {},
    "name": "useCardAdvanceContentNavigation_RestartContentNodeAfterPassedMutation",
    "operationKind": "mutation",
    "text": "mutation useCardAdvanceContentNavigation_RestartContentNodeAfterPassedMutation(\n  $input: RestartContentNodeAfterPassedInput!\n) {\n  LearnV2 {\n    restartContentNodeAfterPassed(input: $input) {\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a52f93d66e9d7155c156ee313600396";

export default node;
